import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/constants";

const beforeKeys = [
  {
    key: "review",
    icon: "ri-star-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20neatly%20arranged%20product%20review%20scene%20with%20a%20five%20star%20rating%20card%2C%20a%20folded%20garment%20and%20a%20smartphone%20showing%20feedback%20on%20a%20bright%20desk%2C%20soft%20daylight%2C%20warm%20minimalist%20editorial%20photography%2C%20clean%20and%20fresh%20composition%2C%20high%20resolution&width=600&height=400&seq=info-review-01&orientation=landscape&nocache=true",
  },
  {
    key: "shipping",
    icon: "ri-truck-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20stack%20of%20neatly%20taped%20brown%20cardboard%20shipping%20boxes%20with%20a%20small%20delivery%20truck%20model%20beside%20them%20on%20a%20light%20surface%2C%20soft%20daylight%2C%20logistics%20editorial%20photography%2C%20clean%20minimal%20composition%20with%20subtle%20shadows%2C%20high%20resolution&width=600&height=400&seq=info-shipping-02&orientation=landscape&nocache=true",
  },
  {
    key: "warehouse",
    icon: "ri-archive-line",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20organized%20warehouse%20shelves%20filled%20with%20labeled%20small%20parcel%20boxes%20and%20storage%20bins%2C%20bright%20clean%20industrial%20lighting%2C%20orderly%20fulfillment%20center%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20fresh%20modern%20composition%2C%20high%20resolution&width=600&height=400&seq=info-warehouse-03&orientation=landscape&nocache=true",
  },
  {
    key: "coupon",
    icon: "ri-ticket-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Colorful%20paper%20discount%20coupons%20and%20a%20pair%20of%20scissors%20arranged%20on%20a%20soft%20pastel%20background%2C%20bright%20cheerful%20daylight%2C%20minimalist%20promotional%20editorial%20photography%2C%20clean%20playful%20composition%2C%20fresh%20modern%20aesthetic%2C%20high%20resolution&width=600&height=400&seq=info-coupon-04&orientation=landscape&nocache=true",
  },
  {
    key: "discount",
    icon: "ri-percent-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20bold%20percentage%20off%20sale%20tag%20hanging%20from%20a%20clothing%20rail%20beside%20a%20folded%20sweater%2C%20bright%20daylight%2C%20retail%20promotion%20editorial%20photography%2C%20clean%20and%20crisp%20composition%2C%20fresh%20modern%20aesthetic%2C%20high%20resolution&width=600&height=400&seq=info-discount-05&orientation=landscape&nocache=true",
  },
  {
    key: "legit",
    icon: "ri-shield-check-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20small%20metallic%20shield%20with%20a%20checkmark%20and%20a%20padlock%20placed%20on%20a%20clean%20light%20surface%20beside%20a%20smartphone%2C%20soft%20daylight%2C%20online%20trust%20and%20security%20editorial%20photography%2C%20clean%20minimal%20composition%2C%20fresh%20modern%20aesthetic%2C%20high%20resolution&width=600&height=400&seq=info-legit-06&orientation=landscape&nocache=true",
  },
];

const compareKeys = ["products", "sellers", "shipping", "qc", "categories", "buying"];

export default function InfoSections() {
  const { t } = useTranslation();

  return (
    <>
      <section id="what" className="bg-background-50">
        <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">
                {t("what.title")}
              </h2>
            </div>
            <div className="space-y-4">
              <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
                {t("what.body1")}
              </p>
              <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
                {t("what.body2")}
              </p>
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-300 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50"
              >
                {t("cta.explore")}
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto w-full max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
          <h2 className="text-center text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("before.title")}
          </h2>
          <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {beforeKeys.map((item) => (
              <a
                key={item.key}
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="group overflow-hidden rounded-xl border border-background-200 bg-white transition-colors hover:border-primary-300"
              >
                <div className="h-40 w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={t(`before.cards.${item.key}.title`)}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-4 text-base font-semibold text-foreground-950">
                    {t(`before.cards.${item.key}.title`)}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    {t(`before.cards.${item.key}.text`)}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section id="compare" className="bg-background-100">
        <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <h2 className="text-center text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("compare.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-center text-sm text-foreground-600 md:text-base">
            {t("compare.subtitle")}
          </p>

          <div className="mt-8 overflow-x-auto rounded-2xl border border-background-200 bg-white">
            <table className="w-full min-w-[720px] text-left text-sm">
              <thead>
                <tr className="border-b border-background-200 bg-background-50">
                  <th className="whitespace-nowrap px-4 py-3 font-semibold text-foreground-950">
                    {t("compare.headers.topic")}
                  </th>
                  <th className="whitespace-nowrap px-4 py-3 font-semibold text-foreground-950">
                    {t("compare.headers.check")}
                  </th>
                  <th className="whitespace-nowrap px-4 py-3 font-semibold text-foreground-950">
                    {t("compare.headers.considerations")}
                  </th>
                  <th className="whitespace-nowrap px-4 py-3 font-semibold text-foreground-950">
                    {t("compare.headers.bestFor")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {compareKeys.map((key, i) => (
                  <tr
                    key={key}
                    className={i % 2 === 0 ? "bg-white" : "bg-background-50"}
                  >
                    <td className="whitespace-nowrap px-4 py-3 font-semibold text-primary-700">
                      {t(`compare.rows.${key}.topic`)}
                    </td>
                    <td className="px-4 py-3 text-foreground-700">
                      {t(`compare.rows.${key}.check`)}
                    </td>
                    <td className="px-4 py-3 text-foreground-600">
                      {t(`compare.rows.${key}.considerations`)}
                    </td>
                    <td className="px-4 py-3 text-foreground-600">
                      {t(`compare.rows.${key}.bestFor`)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <h2 className="text-center text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("how.title")}
          </h2>
          <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {["s1", "s2", "s3", "s4", "s5", "s6"].map((step, i) => (
              <div
                key={step}
                className="rounded-xl border border-background-200 bg-white p-5"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-white">
                    {i + 1}
                  </span>
                  <h3 className="text-base font-semibold text-foreground-950">
                    {t(`how.steps.${step}.title`)}
                  </h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {t(`how.steps.${step}.text`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}